import Vue from 'vue'
import axios from 'axios'

const user = Vue.observable({ user: { role: {} } })
Object.defineProperty(Vue.prototype, '$user', {
  get() {
    return user.user
  },
  set(value) {
    user.user = value
  }
})

const site = Vue.observable({ site: [] })
Object.defineProperty(Vue.prototype, '$site', {
  get() {
    return site.site
  },
  set(value) {
    site.site = value
  }
})

Vue.prototype.$intUser = function () {
  const userData = localStorage.getItem('user')
  if (userData !== null && userData !== 'undefined') {
    try {
      const parsedUser = JSON.parse(userData)
      Vue.set(Vue.prototype, '$user', parsedUser)
    } catch (e) {
      console.error('Invalid JSON in localStorage user:', e)
    }
  }

  const siteData = localStorage.getItem('eSite')
  if (siteData !== null && siteData !== 'undefined') {
    try {
      const parsedSite = JSON.parse(siteData)
      Vue.set(Vue.prototype, '$site', parsedSite)
    } catch (e) {
      console.error('Invalid JSON in localStorage Site:', e)
    }
  }
}

Vue.prototype.$getUser = function () {
  axios
    .get(Vue.prototype.$linkGenerator('/getUser'))
    .then((response) => {
      Vue.set(Vue.prototype, '$user', response.data.data.user)
      Vue.set(Vue.prototype, '$site', response.data.data.site)

      localStorage.setItem('user', JSON.stringify(Vue.prototype.$user))
      localStorage.setItem('eSite', JSON.stringify(Vue.prototype.$site))
    })
    .catch((error) => {
      if (typeof error.response !== 'undefined' && error.response.data == 'toLogin') {
        Vue.prototype.$logout()
      }
    })
}

Vue.prototype.$logout = function () {
  localStorage.removeItem('token')
  localStorage.removeItem('companies')
  localStorage.removeItem('database')
  localStorage.removeItem('company')
  localStorage.removeItem('subdomain')
  localStorage.removeItem('auth')
  localStorage.removeItem('site')
  window.location.hash = '#/login'
}
